import {getFeatureFlag} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/featureFlags';
import {logout as auth0Logout} from './auth0';

export const logout = () => {
    localStorage.clear();
    localStorage.setItem('sessionExpiresTime', new Date().toISOString()); // informs other tabs to log out

    if (getFeatureFlag('auth0_universal_login')) {
        auth0Logout();
    } else {
        window.location.href = '/signout';
    }
};
